import { AfterViewInit, ChangeDetectorRef, Component, Input, OnDestroy, OnInit, ViewRef } from '@angular/core';
import { ReadspeakerElement } from '../../../../../models/readerspeaker-element';
import { ReadspeakerService } from '../../../../../services/readspeaker.service';
import { environment } from '../../../../../../environments/environment';
import { Page } from '../../../../../models/page';
import { CommunicationService } from '../../../../../services/communication.service';
import { Subscription } from 'rxjs';
import { ApplicationStateService } from '../../../../../services/application-state.service';
import { BookFeatureActivationService } from '../../../../../services/book-feature-activation.service';
import { Position } from '../../../../../models/position';
import $ from 'jquery';
import _ from 'lodash';
import { NgStyle } from '@angular/common';

@Component({
    selector: 'app-page-readspeaker',
    templateUrl: './page-readspeaker.component.html',
    styleUrls: ['./page-readspeaker.component.scss'],
    standalone: true,
    imports: [
        NgStyle
    ]
})
export class PageReadspeakerComponent implements OnInit, OnDestroy, AfterViewInit {

    @Input() readspeakerElement: ReadspeakerElement;
    @Input() page: Page;
    link: string;
    eleId: string;
    transform = 'scale(0.5)';
    showButton: boolean;
    calculatedPosition: Position;
    debouncedOnResize: (() => void) & _.Cancelable;
    debouncedDetectChanges: (() => void) & _.Cancelable;
    private zoomSubscription: Subscription;
    private visibilitySubscription: Subscription;
    private pageSizeChangedSubscription: Subscription;
    private rsTimer;

    constructor(private readspeakerService: ReadspeakerService,
                private applicationStateService: ApplicationStateService,
                private communicationService: CommunicationService,
                private changeDetectorRef: ChangeDetectorRef,
                public featureActivationService: BookFeatureActivationService) {

        this.debouncedOnResize = _.debounce(this.onResize, 100);

        this.zoomSubscription = this.communicationService.zoomLevelChangedAnnouncedSource$.subscribe($event => {
            this.transform = `scale(${Math.min(1.2, this.applicationStateService.zoomLevel * 0.5)})`;
            // this.checkVisibility();
            this.debouncedDetectChanges();
            // this.detectChanges();
        });

        this.visibilitySubscription = this.communicationService.readspeakerVisibilityToggledSource$.subscribe(() => {
            // Manually trigger change detection
            this.checkVisibility();
        });

        this.pageSizeChangedSubscription = this.communicationService.pageSizeChangedAnnounced$.subscribe(() => {
            this.updatePosition();
            this.detectChanges();
        });
    }

    ngOnInit(): void {
        this.updatePosition();
        this.checkVisibility();
        this.debouncedDetectChanges = _.debounce(this.detectChanges, 100);

        if (this.showButton) {
            const properties = this.readspeakerService.getReadProperties(this.readspeakerElement);

            let voice = environment.readspeakerVoiceDE;

            if (properties.language === 'en_uk') {
                voice = environment.readspeakerVoiceEN;
            }

            if (properties.url && properties.eleId) {

                this.eleId = properties.eleId;

                this.link = `${environment.readspeakerBaseUrl}?`;
                this.link += [
                    `customerid=${environment.readspeakerCustomerId}`,
                    `lang=${properties.language}`,
                    `readid=${properties.eleId}`,
                    `url=${properties.url}`,
                    `voice=${voice}`
                ].join('&');
            }
        }
    }

    ngOnDestroy(): void {
        this.zoomSubscription.unsubscribe();
        this.visibilitySubscription.unsubscribe();
        this.pageSizeChangedSubscription.unsubscribe();
        if (this.rsTimer) {
            clearTimeout(this.rsTimer);
        }
    }

    ngAfterViewInit(): void {
        this.fixPosition();
        this.reattachClickEventsToReadspeakerButtons();
        this.changeDetectorRef.detach();
    }

    /**
     * Check if the button should be shown.
     *
     * @returns {boolean}
     */
    shouldShowButton(): boolean {
        return this.page.readSpeakerEnabled
            && this.readspeakerElement
            && this.readspeakerElement.enabled
            && this.page.index !== 0;
    }

    checkVisibility(): void {
        // Remove the functionality to show RS buttons only when the page is larger than a minimum size temporally.
        /*const pageWidth = $('.bookviewer-page').first().width();
        if (pageWidth < 480 && this.applicationStateService.zoomLevel < environment.maxZoomLevel / 2 + 0.3) {
            this.showButton = false;
        } else {
            this.showButton = this.shouldShowButton();
        }*/
        this.showButton = this.shouldShowButton();
        this.detectChanges();
    }

    /**
     * After dynamically adding readspeaker buttons, the click events
     * must be re-attached in order for them to function.
     *
     * @from Readspeaker Support
     */
    private reattachClickEventsToReadspeakerButtons(): void {
        const thiz = this;
        this.rsTimer = setTimeout(() => {
            window.window['ReadSpeaker'].q(() => {
                window.window['rspkr'].ui.addClickEvents();
                $(`#readspeaker_button${thiz.eleId} .rsplay`).on('click', () => {
                    thiz.readspeakerService.logUsage(thiz.readspeakerElement);
                });
            });
            this.rsTimer = null;
        }, 500);
    }

    private fixPosition(): void {

        const maxWidth = 88;
        const maxHeight = 98;

        if (!this.readspeakerElement) {
            return;
        }

        // Dirty fix
        setTimeout(() => {

            if (this.readspeakerElement.position.x > maxWidth) {
                this.readspeakerElement.position.x = maxWidth;
            }

            if (this.readspeakerElement.position.w + this.readspeakerElement.position.x > maxWidth) {
                this.readspeakerElement.position.w = maxWidth - this.readspeakerElement.position.x;
            }

            if (this.readspeakerElement.position.h + this.readspeakerElement.position.y > maxHeight) {
                this.readspeakerElement.position.h = maxHeight - this.readspeakerElement.position.y;
            }
        }, 1);
    }

    private updatePosition(): void {
        /**
         *  If the position was changed from the factory in order this component knows if it should
         *  calculate a better position. See #12191.
         */
        if (!this.readspeakerElement) {
            return;
        }

        this.calculatedPosition = new Position();
        this.calculatedPosition.x = this.readspeakerElement.position.x;
        this.calculatedPosition.y = this.readspeakerElement.position.y;

        let btnX = this.readspeakerElement.position.w;
        let btnY = this.readspeakerElement.position.h;

        if (this.readspeakerElement.button.x) {
            btnX *= this.readspeakerElement.button.x / 100;
        }

        if (this.readspeakerElement.button.y) {
            btnY *= this.readspeakerElement.button.y / 100;
        }

        this.calculatedPosition.x += btnX;
        this.calculatedPosition.y += btnY;

        if (this.readspeakerElement.changedPosition) {
            const pages = $('.pages');
            const pageHeightPx = pages.height();
            const pageWidthPx = pages.width();
            this.calculatedPosition.y -= 14 / pageHeightPx * 100;
            this.calculatedPosition.x += 8 / pageWidthPx * 100;
        }
    }

    /**
     * Handler for window resize.
     */
    private onResize(): void {
        // TODO: Comment in when showing RS Button again depends on page size.
        // this.checkVisibility();
    }

    private detectChanges(): void {
        if (!(this.changeDetectorRef as ViewRef).destroyed) {
            this.changeDetectorRef.detectChanges();
        }
    }

}
